const fuchsia = {
  25: "#FEFAFF",
  50: "#FDF4FF",
  100: "#FBE8FF",
  200: "#F6D0FE",
  300: "#EEAAFD",
  400: "#E478FA",
  500: "#D444F1",
  600: "#BA24D5",
  700: "#9F1AB1",
  800: "#821890",
  900: "#6F1877",
  950: "#47104C",
};

export default fuchsia;
